import axios from 'axios';
import { baseUrl } from './config';
import { ILandModel } from '../models/Land';

export const getLands = async () => {
    const url = `${baseUrl}/lands`;
    const res = await axios.get(url);
    return res.data.data.Items as ILandModel[];
};
